import { Component, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "app-share-button",
  templateUrl: "./share-button.component.html",
  styleUrl: "./share-button.component.scss",
})
export class ShareButtonComponent {
  @Output() actionBtnCallback = new EventEmitter<any>();

  onButtonClick(event: any) {
    this.actionBtnCallback.emit(event);
  }
}
